import React from 'react';
import { Missionary } from '../../supabase/types';
import './style.less';

// export type Missionary = {
//     assigned_mission: string
//     email: string
//     missionary_id?: number
//     name: string
//     start_date: string
//     unique_id?: string
//     user_id?:number,
//     subscription_status?:string
// }

interface MissionaryDetailsProps {
    missionary: Missionary;
}

export const MissionaryDetails: React.FC<MissionaryDetailsProps> = ({ missionary }) => {
    return (
        <div className="modern-missionary-details">
            <h3 className="section-title mb-4">Missionary Details</h3>
            
            <div className="details-grid">
                <div className="detail-item">
                    <div className="detail-label">Name</div>
                    <div className="detail-value">{missionary.name}</div>
                </div>

                <div className="detail-item">
                    <div className="detail-label">Email</div>
                    <div className="detail-value">{missionary.email}</div>
                </div>

                {missionary.assigned_mission && (
                    <div className="detail-item">
                        <div className="detail-label">Mission</div>
                        <div className="detail-value">{missionary.assigned_mission}</div>
                    </div>
                )}

                {missionary.start_date && (
                    <div className="detail-item">
                        <div className="detail-label">Start Date</div>
                        <div className="detail-value">
                            {new Date(missionary.start_date).toLocaleDateString()}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MissionaryDetails;
